/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, G, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function PhoneDisconnect(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <G>
        <Path d="M229.82422,90.17578c-56.14551-56.14355-147.501-56.14648-203.64844.001a56.07211,56.07211,0,0,0-4.69043,73.87695,16.03254,16.03254,0,0,0,18.55078,4.99707L87.35059,150.125a15.94917,15.94917,0,0,0,9.74609-11.71875l5.90527-29.51172a76.51611,76.51611,0,0,1,49.67676-.10937v.00195l6.21094,29.73828a15.963,15.963,0,0,0,9.7207,11.584l47.35254,18.9414a16.03618,16.03618,0,0,0,18.55273-4.99805A56.07343,56.07343,0,0,0,229.82422,90.17578Z" />
        <Path d="M216,192H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" />
      </G>
    </Svg>
  );
}

export default PhoneDisconnect;
